import { UserModel } from 'src/models/Account/User';
import { RootState } from 'src/store/store';
import { CurrentUserStateType } from 'src/store/user/slice';

export const currentUserSelector = ({ currentUser }: RootState): CurrentUserStateType => currentUser;

export const currentOrganizationInfoSelector = ({
  currentUser: { response },
}: RootState): UserModel['organizationInfo'] => response?.organizationInfo as UserModel['organizationInfo'];

export const currentUserIsAuthSelector = ({ currentUser: { response } }: RootState): boolean =>
  !!response?.IsAuthenticated;
